import { useContext } from "react";
import { UserContext } from "../Context/UserContextAPI";

export default function useIsOnePackage() {
  const { packages, settingsData } = useContext(UserContext);
  return packages?.length === 1 && settingsData?.agency_package_hide === 1;
}
